module.exports = EventEmitter;